<div id="step-serial-number-validation" class="h-full">
  <div class="flex flex-1 flex-col rounded-card h-full overflow-visible pb-0">
    @if (selectedSaleType == saleType.SERIAL_NUMBER || !selectedSaleType) {
      <form [formGroup]="searchSerialNumberFormGroup" class="row">
        <div class="flex flex-col col-12">
          <h2 data-testid="search-title"  class="pb-2">{{ 'SALE_CREATE.IDENTIFIER_SEARCH' | translate }}</h2>
            @if (noticeMessage) {
            <app-notice class="mb-4" [type]="noticeColor" dataTestId="activate-warranty-hint"
              [wysiwygContent]="noticeMessage">
            </app-notice>
          }
          <label data-testid="search-label" data-testid="serialnumber-search-label" class="block text-sm mb-4" for="search-sn">
            {{ 'WARRANTY_ACTIVATION.INTRODUCE_PRODUCT_SN' | translate }}
            @if (displayTooltipImage()) {
              <tooltip-info [imageUrl]="tooltipImage"></tooltip-info>
            }
          </label>
        </div>
        <div class="relative flex flex-col col-12 col-sm-12 col-md-5 col-lg-6 col-xl-4 mb-4">
          <div class="flex items-stretch camera-btn-field-wr">
            <input data-testid="search" type="text" class="flex-1 w-full" id="serialNumber" formControlName="serialNumber" autocomplete="off" disallowSpaces>
            <textbox-camera data-testid="search-camera"  class="shrink-0 self-stretch flex items-center" (qrCodeScanned)="qrCodeScanned($event)"></textbox-camera>
          </div>
        </div>
        <div class="field-wr flex flex-col col-12 col-md-6">
          <div class="row">
            <div class="field-wr flex flex-col col-12 col-md-8">
              <button data-testid="search-validate-btn" class="btn primary-btn" type="button" [disabled]="searchSerialNumberFormGroup.invalid"
                (click)="onValidateSerialNumber()">
                {{ 'SALE_CREATE.BTN_VALIDATE_SERIAL_NUMBER' | translate }}
              </button>
            </div>
          </div>
        </div>
      </form>
    }

    <form [formGroup]="searchSkuFormGroup" class="row">
      @if (selectedSaleType == saleType.REFERENCE_NUMBER) {
        <div class="flex flex-col col-12">
          <h2 data-testid="search-title" class="pb-2">{{ 'SALE_CREATE.IDENTIFIER_SEARCH' | translate }}</h2>
          <label data-testid="search-label" class="block text-sm mb-4" for="search-sn">{{
            'SALE_CREATE.INTRODUCE_PRODUCT_SKU' | translate
          }}:</label>
        </div>
        <div class="relative flex flex-col col-12 col-sm-12 col-md-5 col-lg-6 col-xl-4">
          <input data-testid="search" type="text" formControlName="sku" autocomplete="off" disallowSpaces>
        </div>
        <div class="field-wr flex flex-col col-12 col-md-6">
          <div class="row">
            <div class="field-wr flex flex-col col-12 col-md-8 col-lg-8 col-xl-6">
              <button data-testid="search-validate-btn" class="btn primary-btn" type="button"
                [disabled]="searchSkuFormGroup.invalid" (click)="onValidateSku()">
                {{ 'SALE_CREATE.BTN_VALIDATE_SKU' | translate }}
              </button>
            </div>
          </div>
        </div>
      }

      @if ((showValues && inMemoryPagedResults.length || identifierError || isLimitedEditionValid)) {
        <section>
          <div class="flex flex-col col-12">
            <h2 data-testid="results" class="pb-2">{{ 'SALE_CREATE.VALIDATION_RESULTS' | translate }}</h2>
          </div>
          <hr role="presentation" class="w-full mt-1 mb-2 border-t">
          @if (isLimitedEditionValid;) {
            <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
              <label data-testid="edition-number" class="block text-sm" for="editionNumber">{{
                'SALE_CREATE.LIMITED_EDITION_NUMBER' | translate }} <i class="icon-required-field"></i></label>
                <app-custom-dropdown
                  data-testid="edition-number"
                  [placeholder]="'SALE_CREATE.SELECT_EDITION_NUMBER' | translate" optionLabel="text"
                  optionValue="id"
                  [isMultiselect]="false"
                  [showSelectionChips]="true"
                  [showClear]="true"
                  [searchMode]="'remote'"
                  [pageSize]="combosData['items'].rowsPerPageOption || 5"
                  [totalCount]="combosData['items'].totalRecords"
                  [totalPages]="getComboTotalPages('items')"
                  [options]="combosData['items'].list"
                  formControlName="editionNumber"
                  (onLazyLoad)="onLazyLoadComboData('items', $event)">
                </app-custom-dropdown>
                @if (searchSkuFormGroup.get('editionNumber')?.hasError('required') && (searchSkuFormGroup.get('editionNumber')?.dirty || searchSkuFormGroup.get('editionNumber')?.touched)) {
                  <small data-testid="edition-number-mandatory" class="p-error">
                    {{ 'FORMS.MANDATORY_FIELD' | translate }}
                  </small>
                }
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                <button data-testid="next-step-btn" class="btn outline-btn w-full" (click)="loadLimitedEdition(item)">
                  {{ 'SALE_CREATE.BTN_NEXT_STEP' | translate }}
                </button>
              </div>
            }
            @if (showValues && inMemoryPagedResults.length;) {
              <section class="row pb-6" >
                <!-- Product results -->
                <ul id="product-results" class="mb-2">
                  <ng-container>
                    @for (item of inMemoryPagedResults; track item; let last = $last; let count = $count) {
                      <li class="product-item row mt-3 mb-3"
                        [attr.product-id]="item.product?.id" [ngClass]="{ 'border-b pb-6' : count > 1 && !last}">
                        <div class="col-12 col-sm-12 col-md-4 col-lg-3">
                          <img data-testid="imageurl" [src]="item?.productCustomisation?.imageUrl || item.product?.imageUrl || item.product?.productType?.imageUrl" class="w-100 mt-2 featured-image"/>
                        </div>
                        <!-- DETAILS -->
                        <div class="col-12 col-sm-12 col-md-8 col-lg-9">
                          <dl class="details-grid">
                            <dt data-testid="name-label" class="label grid-cols-1 pt-3">{{ 'SALE_CREATE.BRAND' | translate }}</dt>
                            <dd data-testid="name" class="value pt-3 pb-3">{{ item.product?.brand?.name }}</dd>
                            <!-- NOT customisable product -->
                            @if (!item.productCustomisation) {
                              <dt data-testid="name-label" class="label grid-cols-1 pt-3">{{ 'SALE_CREATE.PRODUCT_NAME' | translate }}</dt>
                              <dd data-testid="name" class="value pt-3 pb-3">{{ item.product?.name }}</dd>
                              <!-- @if (displaySerialNumber()) { -->
                              <dt data-testid="serialnumber-label" class="label grid-cols-1 pt-3">{{ 'SALE_CREATE.SERIAL_NUMBER' | translate }}</dt>
                              <dd data-testid="serialnumber" class="value pt-3 pb-3">{{ item.serialNumber }}</dd>
                            <!-- } -->
                            <dt data-testid="sku-label" class="label grid-cols-1 pt-3">{{ 'SALE_CREATE.REFERENCE' | translate }}</dt>
                            <dd data-testid="sku" class="value pt-3 pb-3">{{ item.product?.sku | defaultValue }}</dd>
                          } @else {
                            <dt data-testid="name-label" class="label grid-cols-1 pt-3">{{ 'SALE_CREATE.PRODUCT_NAME' | translate }}</dt>
                            <dd data-testid="name" class="value pt-3 pb-3">{{ item.product?.name }}</dd>
                            <dt data-testid="serialnumber-label" class="label grid-cols-1 pt-3">{{ 'SALE_CREATE.SERIAL_NUMBER' | translate }}</dt>
                            <dd data-testid="serialnumber" class="value pt-3 pb-3">{{ item?.serialNumber }}</dd>
                            <dt data-testid="customisation-name-label" class="label grid-cols-1 pt-3">{{ 'PRODUCT_CUSTOMIZATIONS_CREATE.NAME' | translate }}</dt>
                            <dd data-testid="customisation-name" class="value pt-3 pb-3">{{ item.productCustomisation?.name }}</dd>
                          }
                          <!-- Customisable product -->
                        </dl>
                        @if (translatedProductAttributes.length) {
                          <div class="accordion-wr mb-6">
                            <accordion id="product-attributes" [expandIcon]="'icon-arrow-down'" [collapseIcon]="'icon-arrow-up'" [multiple]="true">
                              <accordion-tab [header]="'PRODUCT_SINGLE_VIEW.PRODUCT_ATTRIBUTES' | translate">
                                <dl class="details-grid">
                                  @for (attr of translatedProductAttributes; track attr) {
                                    <dt class="label grid-cols-1 pt-3">
                                      {{ attr.name | defaultValue }}
                                    </dt>
                                    <dd [attr.data-testid]="'product-productAttributes-' + (attr.code || 'unknown')" class="value pt-3 pb-3">
                                      {{ getProductAttributeValue(item.productCustomisation, attr.code) | defaultValue }}
                                    </dd>
                                  }
                                </dl>
                              </accordion-tab>
                            </accordion>
                          </div>
                        }
                        @if (!currentItem) {
                          <div class="row mt-3" >
                            <div class="col-4">
                              <button data-testid="select-product-btn"  class="btn outline-btn w-full" (click)="onSaveStepData(item)">
                                {{ 'SALE_CREATE.SELECT_PRODUCT' | translate }}
                              </button>
                            </div>
                          </div>
                        }
                      </div>
                    </li>
                  }
                </ng-container>
              </ul>
              @if (inMemoryTotalRecords > inMemoryPaginator.rows) {
                <p-paginator [first]="inMemoryPaginator.first"
                  [rows]="inMemoryPaginator.rows" [totalRecords]="inMemoryTotalRecords" (onPageChange)="onInMemoryPageChange($event)">
                </p-paginator>
              }
              <!-- /Product results -->
              <!-- /Product results -->
            </section>
          }
          @if (identifierError) {
            <section>
              @if (identifierError) {
                <p>{{ identifierError }}</p>
              } @else {
                <p data-testid="notfound-error" >{{ 'SALE_CREATE.SERIAL_NUMBER_NO_RESULTS_FOUND' | translate }}</p>
              }
              <br>
                @if (displayItemCreationButton) {
                  <div  class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                    <button data-testid="create-item-btn"  class="btn outline-btn" (click)="onOpenItemModalBox()">
                      {{ 'SALE_CREATE.CREATE_ITEM' | translate }}
                    </button>
                  </div>
                }
              </section>
            }
          </section>
        }


      </form>

    </div>
  </div>

  <!-- Modalbox: create item -->
  <p-dialog [header]="'ITEM_CREATE.BTN_ADD_NEW_ITEM' | translate" [(visible)]="displayItemModalBox" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true" [appendTo]="'body'" [baseZIndex]="1200" class="compact-modal" id="create-item-modalbox">
    <!-- main content -->
    <form class="mt-0" [formGroup]="itemForm">
      <div class="row">
        <div class="flex flex-col col-12 mb-4">
          <h2 data-testid="create-item-details" class="border-b pb-3">{{ 'ITEM_CREATE.ITEM_DETAILS' | translate }}</h2>
        </div>

        <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
          [ngClass]="{ 'disabled': modalProductSelectorDisabled }">
          <label data-testid="item-product-label" class="block text-sm" for="productId">
            {{ 'ITEM_CREATE.PRODUCT' | translate }} <i class="icon-required-field"></i>
          </label>

          <app-custom-dropdown
            data-testid="product"
            [placeholder]="'ITEM_CREATE.SELECT_PRODUCT_PLACEHOLDER' | translate"
            optionLabel="text"
            optionValue="id"
            [isMultiselect]="false"
            [showSelectionChips]="true"
            [showClear]="true"
            [searchMode]="'remote'"
            [pageSize]="combosData['products'].rowsPerPageOption || 5"
            [totalCount]="combosData['products'].totalRecords"
            [totalPages]="getComboTotalPages('products')"
            [options]="modalProductOptions"
            formControlName="productId"
            (onLazyLoad)="onProductsLazyLoad($event)">
          </app-custom-dropdown>

          @if (itemForm.get('productId')?.invalid && itemForm.get('productId')?.touched) {
            <small class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
          }
        </div>

        <div class="field-wr col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
          [ngClass]="{ 'disabled': modalSerialDisabled }">
          <label data-testid="item-serialnumber-label" class="block text-sm mb-2" for="serialNumber">
            {{ 'ITEM_CREATE.SERIAL_NUMBER' | translate }} <i class="icon-required-field"></i>
          </label>
          <div class="flex items-stretch camera-btn-field-wr">
            <input data-testid="item-serialnumber" type="text" class="flex-1 w-full" id="serialNumber"
              formControlName="serialNumber" autocomplete="off" [readonly]="modalSerialDisabled"
              (input)="onInputSerialNumber($event)">
          </div>

          @if (itemForm.get('serialNumber')?.touched) {
            @if (itemForm.get('serialNumber')?.hasError('required')) {
              <small class="p-error">
                {{ 'FORMS.MANDATORY_FIELD' | translate }}
              </small>
            }
            @if (itemForm.get('serialNumber')?.errors?.['maxlength']) {
              <small class="p-error">
                {{ 'FORMS.FIELD_LENGTH_EXCEEDED' | translate }}
              </small>
            }
          }
        </div>

        @if (company.isPrepaired) {
          <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
            <div class="row">
              <div class="col-12">
                <span class="label text-sm">{{ 'ITEM_CREATE.IMPLICIT_CODE_PAIRING' | translate }}</span>
                <label data-testid="implicit-code-yes-label" class="inline-flex mr-6">
                  <p-radioButton data-testid="implicit-code-yes" name="implicitCodePairing" value="true" formControlName="implicitCodePairing"
                    inputId="implicit-code-pairing-yes" />
                  <span for="implicit-code-pairing-yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                </label>
                <label data-testid="implicit-code-no-label" class="inline-flex mr-2">
                  <p-radioButton data-testid="implicit-code-no" name="implicitCodePairing" value="false" formControlName="implicitCodePairing"
                    inputId="implicit-code-pairing-no" />
                  <span for="implicit-code-pairing-no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                </label>
              </div>
            </div>
          </div>
          @if (itemForm.get('implicitCodePairing')?.value === 'false') {
            <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
              <label data-testid="warrantycode-label" class="block text-sm" for="warrantyCode">{{ 'ITEM_CREATE.PREPAIRED_CODE' | translate }} <i
              class="icon-required-field"></i></label>
              <input data-testid="warrantycode-input" type="text" formControlName="warrantyCode" autocomplete="off">
              @if (itemForm.get('warrantyCode')?.touched) {
                @if (itemForm.get('warrantyCode')?.errors?.['maxlength']) {
                  <small class="p-error">
                    {{ 'FORMS.FIELD_LENGTH_EXCEEDED' | translate }}
                  </small>
                }
                @if (itemForm.errors?.['requiredPrepaired'] && company.isPrepaired) {
                  <small data-testid="warrantycode-mandatory" class="p-error">
                    {{ 'FORMS.MANDATORY_FIELD' | translate }}
                  </small>
                }
              }
            </div>
          }
        }

      </div>
      <div class="row">
        <div class="col-12 mt-6 mb-4 pt-8 border-t">
          <div class="flex items-center justify-end gap-3">
            <button data-testid="add-item-btn" type="button" class="btn primary-btn"
              [disabled]="itemForm.invalid" (click)="submitForm()">{{
            'ITEM_CREATE.BTN_ADD_NEW_ITEM' | translate }}</button>
          </div>
        </div>
      </div>
    </form>
    <!-- /main content -->
  </p-dialog>

